import React, { Component } from 'react';
import './style.scss';

class Stepper extends Component {
    state = {};

    constructor(props) {
        super(props);
    }

    render() {
        const {
            stage,
            prevBtnTxt,
            nextBtnTxt,
            cancelBtnTxt,
            setSteps,
            goToStep,
            onClickPrev,
            onClickNext,
            onClickCancel,
        } = this.props;
        const children = React.Children.map(this.props.children, (child) => {
            return React.cloneElement(child, {
                stage,
                prevBtnTxt,
                cancelBtnTxt,
                nextBtnTxt,
                setSteps,
                goToStep,
                onClickPrev,
                onClickNext,
                onClickCancel,
            });
        });
        return <div className="stepper-container">{children}</div>;
    }
}

export default Stepper;
